import Vue from 'vue';
import defaultState from './defaultState';
import * as C from '../constants';

export default {

  // TRANSPORTATION SUPPLIERS
  [C.TRANSPORTATION_SUPPLIERS_LOAD_PENDING](state) {
    Vue.set(state, 'suppliers', {
      ...state.suppliers,
      itemsLoading: true,
      itemsError: undefined,
    });
  },

  [C.TRANSPORTATION_SUPPLIERS_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'suppliers', {
      ...state.suppliers,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.TRANSPORTATION_SUPPLIERS_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'suppliers', {
      ...state.suppliers,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.TRANSPORTATION_DOMAINS_LOAD_PENDING](state) {
    Vue.set(state, 'domains', {
      ...state.domains,
        items: [],
        loading: true,
        error: false,
        selected: null,
    });
  },

  [C.TRANSPORTATION_DOMAINS_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'domains', {
      ...state.domains,
      items: payload,
      loading: false,
      error: false,
    });
  },

  [C.TRANSPORTATION_DOMAINS_LOAD_FAILURE](state) {
    Vue.set(state, 'domains', {
      ...state.domains,
      items: [],
      loading: false,
      error: true,
      selected: null,
    });
  },

  [C.TRANSPORTATION_DOMAINS_SET_DOMAIN](state, payload) {
    Vue.set(state, 'domains', {
      ...state.domains,
      selected: payload,
    });
  },

  [C.TRANSPORTATION_SUPPLIERS_CHANGE](state, payload) {
    Vue.set(state.suppliers, 'supplier', payload);
    Vue.set(state.prices.season, 'selected', null);
  },

  // TRANSPORTATION
  [C.TRANSPORTATION_ACTIVE_TAB_SET](state, payload) {
    Vue.set(state, 'activeTab', payload);
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_CLEAR_STATE](state) {
    Object.assign(state, defaultState());
  },

  // TRANSPORTATION CAR TYPES
  [C.TRANSPORTATION_CAR_TYPES_SEARCH](state, payload) {
    Vue.set(state, 'carTypes', {
      ...state.carTypes,
      search: payload,
    });
  },

  [C.TRANSPORTATION_CAR_TYPES_PAGINATION_CHANGED](state, payload) {
    Vue.set(state.carTypes, 'pagination', payload);
  },

  [C.TRANSPORTATION_CAR_TYPES_SET_ACTIVE](state, payload) {
    Vue.set(state.carTypes, 'carType', payload);
  },

  [C.TRANSPORTATION_CAR_TYPES_LOAD_PENDING](state) {
    Vue.set(state, 'carTypes', {
      ...state.carTypes,
      itemsLoading: true,
      itemsError: undefined,
      supplier: state.suppliers.supplier,
    });
  },

  [C.TRANSPORTATION_CAR_TYPES_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'carTypes', {
      ...state.carTypes,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.TRANSPORTATION_CAR_TYPES_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'carTypes', {
      ...state.carTypes,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.TRANSPORTATION_CAR_TYPES_LOAD_NO_CONTENT](state) {
    Vue.set(state, 'carTypes', {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.TRANSPORTATION_CAR_TYPES_SAVE_PENDING](state) {
    Vue.set(state, 'carTypes', {
      ...state.carTypes,
      saveLoading: true,
      saveError: undefined,
    });
  },

  [C.TRANSPORTATION_CAR_TYPES_SAVE_SUCCESS](state, payload) {
    Vue.set(state, 'carTypes', {
      ...state.carTypes,
      items: payload,
      saveLoading: false,
      saveError: undefined,
    });
  },

  [C.TRANSPORTATION_CAR_TYPES_SAVE_FAILURE](state, payload) {
    Vue.set(state, 'carTypes', {
      ...state.carTypes,
      saveLoading: false,
      saveError: payload,
    });
  },

  [C.TRANSPORTATION_CAR_TYPES_ADD_PENDING](state) {
    Vue.set(state.carTypes, 'saveLoading', true);
    Vue.set(state.carTypes, 'saveError', undefined);
  },

  [C.TRANSPORTATION_CAR_TYPES_ADD_SUCCESS](state) {
    Vue.set(state.carTypes, 'saveLoading', false);
  },

  [C.TRANSPORTATION_CAR_TYPES_ADD_FAILURE](state, payload) {
    Vue.set(state.carTypes, 'saveLoading', false);
    Vue.set(state.carTypes, 'saveError', payload);
  },
  // endregion

  // TRANSPORTATION CABINS
  [C.TRANSPORTATION_CABINS_SEARCH](state, payload) {
    Vue.set(state.cabins, 'search', payload);
  },

  [C.TRANSPORTATION_CABINS_ITEMS_CLEAR](state) {
    Vue.set(state, 'cabins', {
      ...state.cabins,
      route: null,
      items: [],
      itemsLoading: false,
      itemsError: null,
      supplier: state.suppliers.supplier,
    });
  },

  [C.TRANSPORTATION_CABINS_LOAD_PENDING](state) {
    Vue.set(state, 'cabins', {
      ...state.cabins,
      items: [],
      itemsLoading: true,
      itemsError: null,
      supplier: state.suppliers.supplier,
    });
  },

  [C.TRANSPORTATION_CABINS_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'cabins', {
      ...state.cabins,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.TRANSPORTATION_CABINS_LOAD_NO_CONTENT](state) {
    Vue.set(state, 'cabins', {
      ...state.cabins,
      items: [],
      itemsLoading: false,
      itemsError: null,
    });
  },

  [C.TRANSPORTATION_CABINS_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'cabins', {
      ...state.cabins,
      items: payload,
      itemsLoading: false,
      itemsError: null,
    });
  },

  [C.TRANSPORTATION_CABINS_LOAD_PRICES_PENDING](state) {
    Vue.set(state.cabins, 'prices', {
      ...state.cabins.prices,
      items: [],
      loading: true,
      error: null,
    });
  },

  [C.TRANSPORTATION_CABINS_LOAD_PRICES_SUCCESS](state, payload) {
    Vue.set(state.cabins, 'prices', {
      ...state.cabins.prices,
      items: payload,
      loading: false,
      error: null,
    });
  },

  [C.TRANSPORTATION_CABINS_LOAD_PRICES_FAILURE](state, payload) {
    Vue.set(state.cabins, 'prices', {
      ...state.cabins.prices,
      items: [],
      loading: false,
      error: payload,
    });
  },

  [C.TRANSPORTATION_CABINS_SET_ACTIVE](state, payload) {
    Vue.set(state.cabins, 'cabin', payload);
  },

  [C.TRANSPORTATION_CABINS_SAVE_PENDING](state) {
    Vue.set(state, 'cabins', {
      ...state.cabins,
      saveLoading: true,
      saveError: null,
    });
  },

  [C.TRANSPORTATION_CABINS_SAVE_SUCCESS](state, payload) {
    Vue.set(state, 'cabins', {
      ...state.cabins,
      items: payload,
      saveLoading: false,
      saveError: null,
    });
  },

  [C.TRANSPORTATION_CABINS_SAVE_FAILURE](state, payload) {
    Vue.set(state, 'cabins', {
      ...state.cabins,
      saveLoading: false,
      saveError: payload,
    });
  },

  [C.TRANSPORTATION_CABINS_ADD_PENDING](state) {
    Vue.set(state.cabins, 'saveLoading', true);
    Vue.set(state.cabins, 'saveError', null);
  },

  [C.TRANSPORTATION_CABINS_ADD_SUCCESS](state) {
    Vue.set(state.cabins, 'saveLoading', false);
  },

  [C.TRANSPORTATION_CABINS_ADD_FAILURE](state, payload) {
    Vue.set(state.cabins, 'saveLoading', false);
    Vue.set(state.cabins, 'saveError', payload);
  },

  [C.TRANSPORTATION_CABINS_SET_ROUTE](state, payload) {
    Vue.set(state.cabins, 'route', payload);
  },

  // TRANSPORTATION EXTRAS
  [C.TRANSPORTATION_EXTRAS_SEARCH](state, payload) {
    Vue.set(state.extras, 'search', payload);
  },

  [C.TRANSPORTATION_EXTRAS_ITEMS_CLEAR](state) {
    Vue.set(state, 'extras', {
      ...state.extras,
      route: null,
      items: [],
      itemsLoading: false,
      itemsError: null,
      supplier: state.suppliers.supplier,
    });
  },

  [C.TRANSPORTATION_EXTRAS_LOAD_PENDING](state) {
    Vue.set(state, 'extras', {
      ...state.extras,
      items: [],
      itemsLoading: true,
      itemsError: null,
      supplier: state.suppliers.supplier,
    });
  },

  [C.TRANSPORTATION_EXTRAS_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'extras', {
      ...state.extras,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.TRANSPORTATION_EXTRAS_LOAD_NO_CONTENT](state) {
    Vue.set(state, 'extras', {
      ...state.extras,
      items: [],
      itemsLoading: false,
      itemsError: null,
    });
  },

  [C.TRANSPORTATION_EXTRAS_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'extras', {
      ...state.extras,
      items: payload,
      itemsLoading: false,
      itemsError: null,
    });
  },

  [C.TRANSPORTATION_EXTRAS_SET_ACTIVE](state, payload) {
    Vue.set(state.extras, 'extra', payload);
  },

  [C.TRANSPORTATION_EXTRAS_SAVE_PENDING](state) {
    Vue.set(state, 'extras', {
      ...state.extras,
      saveLoading: true,
      saveError: null,
    });
  },

  [C.TRANSPORTATION_EXTRAS_SAVE_SUCCESS](state, payload) {
    Vue.set(state, 'extras', {
      ...state.extras,
      items: payload,
      saveLoading: false,
      saveError: null,
    });
  },

  [C.TRANSPORTATION_EXTRAS_SAVE_FAILURE](state, payload) {
    Vue.set(state, 'extras', {
      ...state.extras,
      saveLoading: false,
      saveError: payload,
    });
  },

  [C.TRANSPORTATION_EXTRAS_ADD_PENDING](state) {
    Vue.set(state.extras, 'saveLoading', true);
    Vue.set(state.extras, 'saveError', null);
  },

  [C.TRANSPORTATION_EXTRAS_ADD_SUCCESS](state) {
    Vue.set(state.extras, 'saveLoading', false);
  },

  [C.TRANSPORTATION_EXTRAS_ADD_FAILURE](state, payload) {
    Vue.set(state.extras, 'saveLoading', false);
    Vue.set(state.extras, 'saveError', payload);
  },

  [C.TRANSPORTATION_EXTRAS_SET_ROUTE](state, payload) {
    Vue.set(state.extras, 'route', payload);
  },

  // TRANSPORTATION ROUTES
  [C.TRANSPORTATION_ROUTES_SEARCH](state, payload) {
    Vue.set(state, 'routes', {
      ...state.routes,
      search: payload,
    });
  },

  [C.TRANSPORTATION_ROUTES_PAGINATION_CHANGED](state, payload) {
    Vue.set(state.routes, 'pagination', payload);
  },

  [C.TRANSPORTATION_ROUTES_LOAD_PENDING](state) {
    Vue.set(state, 'routes', {
      ...state.routes,
      itemsLoading: true,
      itemsError: undefined,
      supplier: state.suppliers.supplier,
    });
  },

  [C.TRANSPORTATION_ROUTES_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'routes', {
      ...state.routes,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.TRANSPORTATION_ROUTES_LOAD_NO_CONTENT](state) {
    Vue.set(state, 'routes', {
      ...state.routes,
      items: [],
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.TRANSPORTATION_ROUTES_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'routes', {
      ...state.routes,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.TRANSPORTATION_ROUTES_SAVE_PENDING](state) {
    Vue.set(state, 'routes', {
      ...state.routes,
      saveLoading: true,
      saveError: undefined,
    });
  },

  [C.TRANSPORTATION_ROUTES_SAVE_SUCCESS](state, payload) {
    Vue.set(state, 'routes', {
      ...state.routes,
      areas: [],
      areasError: undefined,
      areasLoading: false,
      items: payload,
      saveLoading: false,
      saveError: undefined,
    });
  },

  [C.TRANSPORTATION_ROUTES_SAVE_FAILURE](state, payload) {
    Vue.set(state, 'routes', {
      ...state.routes,
      saveLoading: false,
      saveError: payload,
    });
  },

  [C.TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_LOAD_PENDING](state) {
    Vue.set(state, 'routes', {
      ...state.routes,
      checkInInformationsLoading: true,
      checkInInformationsError: undefined,
      saveError: undefined,
    });
  },

  [C.TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'routes', {
      ...state.routes,
      checkInInformations: payload,
      checkInInformationsLoading: false,
      checkInInformationsError: undefined,
    });
  },

  [C.TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_LOAD_NO_CONTENT](state, payload) {
    Vue.set(state, 'routes', {
      ...state.routes,
      checkInInformations: payload,
      checkInInformationsLoading: false,
      checkInInformationsError: undefined,
    });
  },

  [C.TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_LOAD_FAILURE](state, payload, defaultCheckInInformations) {
    Vue.set(state, 'routes', {
      ...state.routes,
      checkInInFormations: defaultCheckInInformations,
      checkInInformationsLoading: false,
      checkInInformationsError: payload,
    });
  },

  [C.TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_SAVE_PENDING](state) {
    Vue.set(state, 'routes', {
      ...state.routes,
      saveLoading: true,
      saveError: undefined,
    });
  },

  [C.TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_SAVE_SUCCESS](state) {
    Vue.set(state, 'routes', {
      ...state.routes,
      saveLoading: false,
    });
  },

  [C.TRANSPORTATION_ROUTES_CHECK_IN_INFORMATION_SAVE_FAILURE](state, payload) {
    Vue.set(state, 'routes', {
      ...state.routes,
      saveLoading: false,
      saveError: payload,
    });
  },

  [C.TRANSPORTATION_ROUTES_SET_ACTIVE](state, payload) {
    Vue.set(state.routes, 'route', payload);
  },

  [C.TRANSPORTATION_ROUTES_AREAS_LOAD_PENDING](state) {
    Vue.set(state, 'routes', {
      ...state.routes,
      areas: [],
      areasLoading: true,
      areasError: undefined,
    });
  },

  [C.TRANSPORTATION_ROUTES_AREAS_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'routes', {
      ...state.routes,
      areas: payload,
      areasLoading: false,
    });
  },

  [C.TRANSPORTATION_ROUTES_AREAS_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'routes', {
      ...state.routes,
      areasLoading: false,
      areasError: payload,
    });
  },

  [C.TRANSPORTATION_ROUTES_AREAS_ADD](state, payload) {
    state.routes.areas.push(payload);
  },

  [C.TRANSPORTATION_ROUTES_AREAS_TOGGLE](state, payload) {
    Vue.set(state.routes.areas, payload, {
      ...state.routes.areas[payload],
      deleted: !state.routes.areas[payload].deleted,
    });
  },

  [C.TRANSPORTATION_ROUTES_AREAS_DELETE](state, payload) {
    state.routes.areas.splice(payload, 1);
  },

  [C.TRANSPORTATION_ROUTES_AREAS_REPLACE_ALL](state, payload) {
    Vue.set(state.routes, 'areas', payload);
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_TEXT_TAGS_LOAD_PENDING](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      tags: [],
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.TRANSPORTATION_ROUTES_TEXT_TAGS_LOAD_SUCCESS](state, payload) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      tags: payload,
      loading: false,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_TEXT_TAGS_LOAD_FAILURE](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      tags: [],
      loading: false,
      error: true,
    });
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_TEXTS_LOAD_PENDING](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      items: [],
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.TRANSPORTATION_ROUTES_TEXTS_LOAD_SUCCESS](state, payload) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      items: payload,
      loading: false,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_TEXTS_LOAD_FAILURE](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      items: [],
      loading: false,
      error: true,
    });
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_CREATE_TEXT_PENDING](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      items: [],
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_CREATE_TEXT_SUCCESS](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      items: [],
      loading: false,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_CREATE_TEXT_FAILURE](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      items: [],
      loading: false,
      error: true,
    });
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_UPDATE_TEXT_PENDING](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_UPDATE_TEXT_SUCCESS](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      loading: false,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_UPDATE_TEXT_FAILURE](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      loading: false,
      error: true,
    });
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_DELETE_TEXT_PENDING](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_DELETE_TEXT_SUCCESS](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      loading: false,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_DELETE_TEXT_FAILURE](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      loading: false,
      error: true,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.TRANSPORTATION_ROUTES_CHANGE_TEXT](state, payload) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.TRANSPORTATION_ROUTES_TEXTS_CLEAR_LIST](state) {
    Vue.set(state.routes, 'texts', {
      ...state.routes.texts,
      items: [],
      loading: false,
      error: false,
    });
  },


  // TRANSPORTATION PERSON CATEGORIES
  [C.TRANSPORTATION_PERSON_CATEGORIES_LOAD_PENDING](state) {
    Vue.set(state, 'personCategories', {
      ...state.personCategories,
      itemsLoading: true,
      itemsError: undefined,
      supplier: state.suppliers.supplier,
    });
  },

  [C.TRANSPORTATION_PERSON_CATEGORIES_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'personCategories', {
      ...state.personCategories,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.TRANSPORTATION_PERSON_CATEGORIES_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'personCategories', {
      ...state.personCategories,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.TRANSPORTATION_PERSON_CATEGORIES_LOAD_NO_CONTENT](state) {
    Vue.set(state, 'personCategories', {
      ...state.personCategories,
      items: [],
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.TRANSPORTATION_PERSON_CATEGORIES_SEARCH](state, payload) {
    Vue.set(state.personCategories, 'search', payload);
  },

  [C.TRANSPORTATION_PERSON_CATEGORIES_SET_ACTIVE](state, payload) {
    Vue.set(state.personCategories, 'personCategory', payload);
  },

  [C.TRANSPORTATION_PERSON_CATEGORIES_PAGINATION_CHANGED](state, payload) {
    Vue.set(state.personCategories, 'pagination', payload);
  },

  [C.TRANSPORTATION_PERSON_CATEGORIES_SAVE_PENDING](state) {
    Vue.set(state, 'personCategories', {
      ...state.personCategories,
      saveLoading: true,
      saveError: undefined,
    });
  },

  [C.TRANSPORTATION_PERSON_CATEGORIES_SAVE_SUCCESS](state, payload) {
    Vue.set(state, 'personCategories', {
      ...state.personCategories,
      items: payload,
      saveLoading: false,
      saveError: undefined,
    });
  },

  [C.TRANSPORTATION_PERSON_CATEGORIES_SAVE_FAILURE](state, payload) {
    Vue.set(state, 'personCategories', {
      ...state.personCategories,
      saveLoading: false,
      saveError: payload,
    });
  },

  [C.TRANSPORTATION_PERSON_CATEGORIES_ADD_PENDING](state) {
    Vue.set(state.personCategories, 'saveLoading', true);
    Vue.set(state.personCategories, 'saveError', undefined);
  },

  [C.TRANSPORTATION_PERSON_CATEGORIES_ADD_SUCCESS](state) {
    Vue.set(state.personCategories, 'saveLoading', false);
  },

  [C.TRANSPORTATION_PERSON_CATEGORIES_ADD_FAILURE](state, payload) {
    Vue.set(state.personCategories, 'saveLoading', false);
    Vue.set(state.personCategories, 'saveError', payload);
  },

  // TRANSPORTATION PRICES
  [C.TRANSPORTATION_PRICES_SET_ROUTE](state, payload) {
    Vue.set(state.prices, 'route', payload);
  },
  [C.TRANSPORTATION_PRICES_CLEAR](state) {
    Vue.set(state, 'departures', {
      ...state.departures,
      items: [],
      loading: false,
      error: false,
    });
    Vue.set(state.ferry.season.prices, 'item', null);
  },

  // TRANSPORTATION PRICES SEASON
  [C.TRANSPORTATION_PRICES_SEASONS_LOAD_PENDING](state) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      items: [],
      loading: true,
      error: null,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASONS_LOAD_SUCCESS](state, payload) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      items: payload,
      loading: false,
      error: null,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASONS_LOAD_FAILURE](state, payload) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      items: [],
      loading: false,
      error: payload,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASONS_LOAD_NO_CONTENT](state) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      items: [],
      loading: false,
      error: null,
    });
  },
  [C.TRANSPORTATION_PRICES_SET_SEASON](state, payload) {
    Vue.set(state.prices.season, 'selected', payload);
  },
  [C.TRANSPORTATION_PRICES_UNSET_SEASON](state) {
    Vue.set(state.prices.season, 'selected', null);
    Vue.set(state.ferry.season, 'selected', null);
    Vue.set(state.ferry.season, 'prices', {
      ...state.ferry.season.prices,
      item: null,
      loading: false,
      error: null,
    });
    Vue.set(state, 'departures', {
      ...state.departures,
      items: [],
      loading: false,
      error: null,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASONS_FERRY_LOAD_PENDING](state) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      items: [],
      loading: true,
      error: null,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASONS_FERRY_LOAD_SUCCESS](state, payload) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      items: payload,
      loading: false,
      error: null,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASONS_FERRY_LOAD_FAILURE](state, payload) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      items: [],
      loading: false,
      error: payload,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASONS_FERRY_LOAD_NO_CONTENT](state) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      items: [],
      loading: false,
      error: null,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_FERRY_LOAD_PENDING](state) {
    Vue.set(state.ferry.season, 'prices', {
      ...state.ferry.season.prices,
      item: null,
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_FERRY_LOAD_SUCCESS](state, payload) {
    Vue.set(state.ferry.season, 'prices', {
      ...state.ferry.season.prices,
      item: payload,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_FERRY_LOAD_FAILURE](state) {
    Vue.set(state.ferry.season, 'prices', {
      ...state.ferry.season.prices,
      item: null,
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_FERRY_LOAD_NO_CONTENT](state) {
    Vue.set(state.ferry.season, 'prices', {
      ...state.ferry.season.prices,
      item: null,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_SET_FERRY_SEASON](state, payload) {
    Vue.set(state.prices.season, 'selected', payload);
  },
  [C.TRANSPORTATION_PRICES_SEASON_FERRY_UPDATE_PENDING](state) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      loading: true,
      error: null,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_FERRY_UPDATE_SUCCESS](state) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      loading: false,
      error: null,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_FERRY_UPDATE_FAILURE](state, payload) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      loading: false,
      error: payload,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_FERRY_SAVE_PRICE_PENDING](state) {
    Vue.set(state.ferry.season, 'prices', {
      ...state.ferry.season.prices,
      loading: true,
      error: null,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_FERRY_SAVE_PRICE_SUCCESS](state) {
    Vue.set(state.ferry.season, 'prices', {
      ...state.ferry.season.prices,
      loading: false,
      error: null,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_FERRY_SAVE_PRICE_FAILURE](state, payload) {
    Vue.set(state.ferry.season, 'prices', {
      ...state.ferry.season.prices,
      loading: false,
      error: payload,
    });
  },

  // TRANSPORTATION PRICES DEPARTURE
  [C.TRANSPORTATION_PRICES_DEPARTURE_SET](state, departure) {
    Vue.set(state.prices.season, 'selectedDeparture', departure);
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_SET_DIRECTION](state, payload) {
    Vue.set(state.prices.season, 'selectedDeparture', {
      ...state.prices.season.selectedDeparture,
      direction: payload,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_ADD_PENDING](state) {
    Vue.set(state, 'departures', {
      ...state.departures,
      items: [],
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_ADD_SUCCESS](state) {
    Vue.set(state, 'departures', {
      ...state.departures,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_ADD_FAILURE](state) {
    Vue.set(state, 'departures', {
      ...state.departures,
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURES_PENDING](state) {
    Vue.set(state, 'departures', {
      ...state.departures,
      items: [],
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURES_SUCCESS](state, payload) {
    Vue.set(state, 'departures', {
      ...state.departures,
      items: payload,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURES_FAILURE](state) {
    Vue.set(state, 'departures', {
      ...state.departures,
      items: [],
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURES_NO_CONTENT](state) {
    Vue.set(state, 'departures', {
      ...state.departures,
      items: [],
      loading: false,
      error: false,
    });
  },

  // TRANSPORTATION PRICES DEPARTURE DAYS
  [C.TRANSPORTATION_PRICES_DEPARTURE_DAYS_PENDING](state) {
    Vue.set(state.departures, 'days', {
      ...state.departures.days,
      items: [],
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_DAYS_SUCCESS](state, payload) {
    Vue.set(state.departures, 'days', {
      ...state.departures,
      items: payload,
      filteredItems: payload.map(departure => departure.availableAt),
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_DAYS_FAILURE](state) {
    Vue.set(state.departures, 'days', {
      ...state.departures.days,
      items: [],
      filteredItems: [],
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_DAYS_SAVE_PENDING](state) {
    Vue.set(state.departures, 'days', {
      ...state.departures.days,
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_DAYS_SAVE_SUCCESS](state) {
    Vue.set(state.departures, 'days', {
      ...state.departures.days,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_DAYS_SAVE_FAILURE](state) {
    Vue.set(state.departures, 'days', {
      ...state.departures.days,
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_DAYS_DELETE_PENDING](state) {
    Vue.set(state.departures, 'days', {
      ...state.departures.days,
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_DAYS_DELETE_SUCCESS](state) {
    Vue.set(state.departures, 'days', {
      ...state.departures.days,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_DAYS_DELETE_FAILURE](state) {
    Vue.set(state.departures, 'days', {
      ...state.departures.days,
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_SAVE_PENDING](state) {
    Vue.set(state, 'departures', {
      ...state.departures,
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_SAVE_SUCCESS](state) {
    Vue.set(state, 'departures', {
      ...state.departures,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_SAVE_FAILURE](state) {
    Vue.set(state, 'departures', {
      ...state.departures,
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_DELETE_PENDING](state) {
    Vue.set(state, 'departures', {
      ...state.departures,
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_DELETE_SUCCESS](state) {
    Vue.set(state, 'departures', {
      ...state.departures,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_DELETE_FAILURE](state) {
    Vue.set(state, '', {
      ...state.departures,
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_ADD_PENDING](state) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_ADD_SUCCESS](state) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_ADD_FAILURE](state) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_UPDATE_PENDING](state) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      loading: true,
      error: null,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_UPDATE_SUCCESS](state) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      loading: false,
      error: null,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASON_UPDATE_FAILURE](state, payload) {
    Vue.set(state.prices, 'season', {
      ...state.prices.season,
      loading: false,
      error: payload,
    });
  },
  [C.TRANSPORTATION_PRICES_SEASONS_LIST_UPDATE](state, payload) {
    Vue.set(state.prices.season.items, payload.index, {
      ...state.prices.season.items[payload.index],
      startDate: payload.startDate,
      endDate: payload.endDate,
    });
  },

  // TRANSPORTATION PRICES DEPARTURE CABINS
  [C.TRANSPORTATION_PRICES_DEPARTURE_CABINS_LOAD_PENDING](state) {
    Vue.set(state.departures, 'cabins', {
      ...state.departures.cabins,
      items: [],
      prices: [],
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_CABINS_LOAD_SUCCESS](state, payload) {
    Vue.set(state.departures, 'cabins', {
      ...state.departures.cabins,
      items: payload,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_CABINS_LOAD_FAILURE](state) {
    Vue.set(state.departures, 'cabins', {
      ...state.departures.cabins,
      items: [],
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_CABINS_LOAD_NO_CONTENT](state) {
    Vue.set(state.departures, 'cabins', {
      ...state.departures.cabins,
      items: [],
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICES_LOAD_PENDING](state) {
    Vue.set(state.departures, 'cabins', {
      ...state.departures.cabins,
      prices: [],
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICES_LOAD_SUCCESS](state, payload) {
    Vue.set(state.departures, 'cabins', {
      ...state.departures.cabins,
      prices: payload,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICES_LOAD_FAILURE](state) {
    Vue.set(state.departures, 'cabins', {
      ...state.departures.cabins,
      prices: [],
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_SAVE_PENDING](state) {
    Vue.set(state.departures, 'cabins', {
      ...state.departures.cabins,
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_SAVE_SUCCESS](state) {
    Vue.set(state.departures, 'cabins', {
      ...state.departures.cabins,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_SAVE_FAILURE](state) {
    Vue.set(state.departures, 'cabins', {
      ...state.departures,
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_DELETE_PENDING](state) {
    Vue.set(state.departures, 'cabins', {
      ...state.departures.cabins,
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_DELETE_SUCCESS](state) {
    Vue.set(state.departures, 'cabins', {
      ...state.departures.cabins,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_CABINS_PRICE_DELETE_FAILURE](state) {
    Vue.set(state.departures, 'cabins', {
      ...state.departures.cabins,
      loading: false,
      error: true,
    });
  },

  // TRANSPORTATION PRICES DEPARTURE EXTRAS
  [C.TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_LOAD_PENDING](state) {
    Vue.set(state.departures, 'extras', {
      ...state.departures.extras,
      items: [],
      prices: [],
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_LOAD_SUCCESS](state, payload) {
    Vue.set(state.departures, 'extras', {
      ...state.departures.extras,
      items: payload,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_LOAD_FAILURE](state) {
    Vue.set(state.departures, 'extras', {
      ...state.departures.extras,
      items: [],
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_PENDING](state) {
    Vue.set(state.departures, 'extras', {
      ...state.departures.extras,
      prices: [],
      loading: true,
      error: false,
    });
  },

  [C.TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_SUCCESS](state, payload) {
    Vue.set(state.departures, 'extras', {
      ...state.departures.extras,
      prices: payload,
      loading: false,
      error: false,
    });
  },

  [C.TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_FAILURE](state) {
    Vue.set(state.departures, 'extras', {
      ...state.departures.extras,
      prices: [],
      loading: false,
      error: true,
    });
  },

  [C.TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_SAVE_PENDING](state) {
    Vue.set(state.departures, 'extras', {
      ...state.departures.extras,
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_SAVE_SUCCESS](state) {
    Vue.set(state.departures, 'extras', {
      ...state.departures.extras,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_SAVE_FAILURE](state) {
    Vue.set(state.departures, 'extras', {
      ...state.departures.extras,
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_DELETE_PENDING](state) {
    Vue.set(state.departures, 'extras', {
      ...state.departures.extras,
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_DELETE_SUCCESS](state) {
    Vue.set(state.departures, 'extras', {
      ...state.departures.extras,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_EXTRAS_PRICE_DELETE_FAILURE](state) {
    Vue.set(state.departures, 'extras', {
      ...state.departures.extras,
      loading: false,
      error: false,
    });
  },

  // TRANSPORTATION PRICES DEPARTURE BLOCK DAY
  [C.TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_PENDING](state) {
    Vue.set(state.departures, 'blockDays', {
      ...state.departures.blockDays,
      items: [],
      filteredItems: [],
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SUCCESS](state, payload) {
    Vue.set(state.departures, 'blockDays', {
      ...state.departures.blockDays,
      items: payload,
      filteredItems: payload.map(seasonBlockDay => seasonBlockDay.blockedAt),
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_FAILURE](state) {
    Vue.set(state.departures, 'blockDays', {
      ...state.departures.blockDays,
      items: [],
      filteredItems: [],
      loading: false,
      error: true,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SAVE_PENDING](state) {
    Vue.set(state.departures, 'blockDays', {
      ...state.blockDays,
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SAVE_SUCCESS](state) {
    Vue.set(state.departures, 'blockDays', {
      ...state.departures,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SAVE_FAILURE](state) {
    Vue.set(state.departures, 'blockDays', {
      ...state.departures.blockDays,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_DELETE_PENDING](state) {
    Vue.set(state.departures, 'blockDays', {
      ...state.departures.blockDays,
      items: [],
      loading: true,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SAVE_SUCCESS](state) {
    Vue.set(state.departures, 'blockDays', {
      ...state.departures.blockDays,
      loading: false,
      error: false,
    });
  },
  [C.TRANSPORTATION_PRICES_DEPARTURE_BLOCK_DAYS_SAVE_FAILURE](state) {
    Vue.set(state.departures, 'blockDays', {
      ...state.departures.blockDays,
      loading: false,
      error: true,
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/transportation/mutations.js